import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { Outlet, useLocation } from 'react-router';

// UI
import PageFooter from '@components/info-page-footer';
import PageHeader from '@components/info-page-header';
import { NotificationProvider } from '@store/notifications';
import Notifications from '@components/notifications-list';

// styles
import css from './styles.module.css';

interface IProps {
  className?: string;
}

const InfoPageLayout: React.FC<IProps> = ({ className }) => {
  const location = useLocation();

  useEffect(() => {
    document.body.classList.add('adjust-for-lk-pages');

    return () => {
      document.body.classList.remove('adjust-for-lk-pages');
    };
  }, []);

  const isSpecialPage = location.pathname.includes('/feedback');

  return (
    <NotificationProvider>
      <div className={clsx(css.infoPageLayoutWrapper, className)}>
        <PageHeader />
        <div className={css.contentWrapper}>
          <div
            className={clsx(css.innerWrapper, {
              [css.specialPage]: isSpecialPage,
            })}
          >
            <Outlet />
          </div>
        </div>
        <PageFooter />
      </div>
      <Notifications />
    </NotificationProvider>
  );
};

export default InfoPageLayout;
